import axios from "@/axios";

export const namespaced = true

const defaultData = {
    orderId: 0,
    financeSystemId: null,
}

export const state = {
    orderFinanceSystem: {},
}


export const getters = {
    orderFinanceSystem: (state) => state.orderFinanceSystem,
}

export const mutations = {
    SET_ORDER_FINANCE_SYSTEM: (state, response) => {
        state.orderFinanceSystem = response.data
    }
}

export const actions = {
    async getOrderFinanceSystem({ commit }, orderId) {
        commit("SET_ORDER_FINANCE_SYSTEM", await axios.get(`/api/orderfinancesystems/${orderId}`))
    },
    async saveOrderFinanceSystem({ commit, state }, orderId) {
        state.orderFinanceSystem.orderId = orderId;
        return await axios.post('/api/orderfinancesystems/', state.orderFinanceSystem)
    },
}
